import React from 'react';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';
import { modalActionType } from 'utils/constants';
import Preview from '../ModalsContent/Preview';
import SearchSubject from '../ModalsContent/SearchSubject';
import ChildOf from '../ModalsContent/ChildOf';
import UploadProgress from '../ModalsContent/UploadProgress';

interface Props {
  activeFile?: string;
  pageNumber?: number;
  pageRotation?: number;
  percentage: number;
  filename: string;
}

const ModalsContent = (props: Props) => {
  const { activeFile, pageRotation, percentage, filename, pageNumber } = props;

  const actionType = useSelector(selectors.modal.getActionType);

  switch (actionType) {
    case modalActionType.pdfUploader.PDF_PREVIEW:
      return activeFile && pageNumber ? (
        <Preview pageRotation={pageRotation || 0} docImage={activeFile} pageNumber={pageNumber} />
      ) : (
        <p>Ops! Something went wrong!</p>
      );
    case modalActionType.pdfUploader.SEARCH_SUBJECT:
      return <SearchSubject />;
    case modalActionType.pdfUploader.CHILD_OF:
      return <ChildOf />;
    case modalActionType.pdfUploader.UPLOAD_PROGRESS:
      return <UploadProgress percentage={percentage} name={filename} />;
    default:
      return null;
  }
};

export default ModalsContent;
